import { Container, Content } from './styles';

interface LeagueProps {
  id: number;
  nome: string;
  privada: boolean;
  createdAt: string;
}

interface LeagueAPIResponse {
  liga: LeagueProps;
  num_participantes: number;
}

interface CardProps {
  league: LeagueAPIResponse;
  openJoinLeagueModal?: (league: LeagueProps) => void;
}

export const Card: React.FC<CardProps> = ({
  league,
  openJoinLeagueModal,
}: CardProps) => {
  return (
    <Container
      onClick={() => openJoinLeagueModal && openJoinLeagueModal(league.liga)}
    >
      <Content>
        <span>{/* <img src={league.image} alt={`${league.title}`} /> */}</span>

        <div>
          <span>
            <h1>{league.liga.nome}</h1>
            <h2>
              {league.num_participantes}
              {league.num_participantes === 1
                ? ' Participante'
                : ' Participantes'}
            </h2>
          </span>
        </div>
      </Content>
    </Container>
  );
};
